import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { twitter, twitterX } from './mocks/social-icons.mocks';
import { ContentSocialIcon } from './models/social-icons.interfaces';

@Component({
  selector: 'idp-social-icons',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './social-icons.component.html',
  styleUrls: ['./social-icons.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SocialIconsComponent {
  @Input() iconsContent: ContentSocialIcon[] = [];
  @Output() iconClick = new EventEmitter<ContentSocialIcon>();
  @Output() analyticsEvent = new EventEmitter<HTMLElement>();
  onIconClick(icon: ContentSocialIcon): void {
    this.iconClick.emit(icon);
  }

  identifyIcon(iconAlt: string): string {
    return iconAlt && iconAlt.toLowerCase() == twitter ? twitterX : iconAlt;
  }
}
